import type { FileWithPath } from 'react-dropzone'
import type { QUALITY_IDENTIFIER } from '~/const/asset'

export interface IAssetTag {
  asset_id: string
  key: string
  value: string[]
}

export interface IAssetFile {
  bucket: string
  created_at: number
  created_by: string
  download_url: string
  id: string
  mime_type: string
  name: string
  path: string
  quality_identifier: string
  size: number
  status: string
  storage: string
  updated_at: number
  updated_by: string
}

export interface IAsset {
  created_at: number
  created_by: string
  custom_digest: string
  expiration_date: number | null
  file_type: string
  files: IAssetFile[] | null
  id: string
  name: string
  status: ASSET_STATUS
  tags: IAssetTag[]
  updated_at: number
  updated_by: string
}

export interface IAssetCreate extends Pick<IAsset, 'expiration_date' | 'file_type' | 'name' | 'status'> {
  file_quality_ids: IAssetFileQuality[]
  platform: ASSET_PLATFORM
  tags: Omit<IAssetTag, 'asset_id'>[]
}

export interface IAssetUpdate extends Pick<IAsset, 'name' | 'expiration_date' | 'id' | 'file_type' | 'status'> {
  file_quality_ids?: IAssetFileQuality[]
  tags: Omit<IAssetTag, 'asset_id'>[]
}

export enum ASSET_STATUS {
  DEPRECATED = 'deprecated',
  DRAFT = 'draft',
  DRAFT_ABORTED = 'draft_aborted',
  RELEASED = 'released',
  STOPPED = 'stopped',
}

export enum ASSET_PLATFORM {
  ANDROID = 'android',
  IOS = 'ios',
  UNITY = 'unity',
}
export type IAssetFileQuality = { file_id: string; qualifier: QUALITY_IDENTIFIER }

export type IAssetProperty = {
  key: IOption | null
  value: string
}

export interface IAssetFileWithQualifier
  extends Omit<
    FileWithPath,
    'lastModified' | 'webkitRelativePath' | 'arrayBuffer' | 'slice' | 'stream' | 'text' | 'prototype'
  > {
  file_id: string
  objectURL: string
  qualifier: QUALITY_IDENTIFIER
}
